import { HeroForm } from "components/HeroForm";
import type { ReactStoryblokComponent } from "types/storyblok";
import { buttonVaringsConfig, INFO_CHECKMARKS } from "./HeroForm.config";
import type { HeroFormAdapterProps } from "./HeroForm.d";

const HeroFormAdapter = ({
  blok: { buttonText, ctaVariant, checkmarks = [], hideCheckmarks },
  sbEditable,
}: ReactStoryblokComponent<HeroFormAdapterProps>) => {
  const checkboxes = checkmarks?.length > 0 ? checkmarks.map(({ text }) => text) : INFO_CHECKMARKS;

  return (
    <HeroForm
      buttonText={buttonText}
      ctaVariant={buttonVaringsConfig[ctaVariant]}
      checkmarks={checkboxes}
      hideCheckmarks={hideCheckmarks}
      sbEditable={sbEditable}
    />
  );
};

export default HeroFormAdapter;
